'use strict';

(yalwa.contact = function(pub) {
	pub = pub || {};
	
	pub.init = function() {
		jQuery('.js-faq_contact_form input').on('invalid', function() {
			jQuery('.js-main_col').scrollTop(0);
		});
	};
	
	return pub;
	
}(yalwa.contact));

yalwa.basics.init_wrapper(yalwa.contact.init);